module.exports = __webpack_public_path__ + "static/media/T7-01.f85f12e2.svg";